<template>
    <DefaultPanel class="tour-panel" title="Tour selezionato" selectable :is-selected="true">
        <template>
            <div class="row no-gutters">
                <div class="col-12 col-md-4">
                    <small-carousel :images="images"/>
                </div>
                <div class="col-12 col-md-8 right">
                    <div>
                        <div class="border-bottom pb-1">
                            <div class="d-flex justify-content-between">
                                <h6 class="text-primary text-uppercase mb-0">{{line}}</h6>
                                <div>
                                    <img src="../../../../assets/images/svg/black/icone_durata.svg" height="18px"/>
                                    <b class="text-uppercase">{{period}}</b>
                                </div>
                            </div>
                            <h4 class="mb-1">{{name}}</h4>
                        </div>
                        <div  v-if="descrizione"  class="border-bottom pb-2">
                            <div style="height: 35px; overflow: hidden">
                                <img src="../../../../assets/images/svg/black/icone_lingua.svg" height="12px"/>
                                <span class="font-italic">{{descrizione}}</span>
                            </div>
                        </div>
                        <div>
                            <div v-for="(group, index) in groups" :key="index">
                                <div class="mb-2">
                                    <small class="text-uppercase">Camera {{index + 1}}</small>
                                    <select class="form-control" :index="index" @change="(event) => onRoomChange(event, index)">
                                        <option v-for="(item, index2) in group.prices" :key="index2" :selected="item.selected">
                                            {{item.category}}{{index2? ': + ' + delta(group.prices, item.price.venditaTotaleEuro) + '&euro;' : ''}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-end">
                            <h6 v-if="!modified" class="text-primary default-bold text-uppercase position-relative mr-2" style="top: 7px">selezionato</h6>
                            <button v-else class="btn btn-primary py-1" @click="onConfirmPrice">Modifica</button>
                            <div class="icon-circle-border-blue ml-1">
                                <a href="javascript:void(0)" @click="onDetail">
                                    <img src="../../../../assets/images/svg/blue/icone_dettagli.svg" width="16px"/>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:modal>
            <ModalTourDetail :value="value" ref="modalTourDetail" :hideForm="true"/>
        </template>
    </DefaultPanel>
</template>
<script>
import {mapActions} from 'vuex'
import DefaultPanel from '../../../templates/DefaultPanel'
import {Carousel, Slide} from 'vue-carousel'
import ModalTourDetail from './modals/ModalTourDetail'
import {middleDateFormatter, toDateFromServer} from '../../../../utils/formatter'
import {tourName} from '../../../../utils/helper'
import SmallCarousel from '../../common/SmallCarousel'
import AnalyticEvents from '../../../common/AnalyticEvents'

export default {
  name: 'TourPanel',
  mixins: [AnalyticEvents],
  components: { SmallCarousel, ModalTourDetail, Carousel, Slide, DefaultPanel },
  props: {
    value: {
      type: Object
    },
    minimize: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      modified: false,
      groups: this.makeGroups()
    }
  },
  computed: {
    detail () {
      return this.value.anagrafica ? this.value.anagrafica.detailResponse.detail : this.value.detailResponses[0].detail
    },
    element () {
      return this.value.element
    },
    days () {
      return this.detail.days
    },
    nights () {
      return this.detail.nights
    },
    descrizione () {
      return this.detail.description
    },
    line () {
      return this.detail.line
    },
    name () {
      return tourName(this.detail.name)
    },
    date () {
      return middleDateFormatter(toDateFromServer(this.detail.departureDate.date))
    },
    images () {
      return this.detail.dayByDay.map(item => item.imagesUrl).reduce((t, c) => t.concat(c))
    },
    period () {
      const start = toDateFromServer(this.value.date.date)
      const end = this.$moment(start).add(this.days - 1, 'days').toDate()
      return middleDateFormatter(start) + ' - ' + middleDateFormatter(end)
    }
  },
  methods: {
    ...mapActions(['updateTourPriceSelection']),
    onDetail () {
      const start = toDateFromServer(this.value.date.date)
      this.trackTabTourModificaInfo()
      this.$refs.modalTourDetail.open(start)
    },
    makeGroups () {
      const list = this.value.detailResponses.map(response => {
        return {
          travelGroupId: response.prices[0].groupId,
          prices: response.prices
        }
      })
      return list
    },
    onRoomChange (event, groupIndex) {
      this.groups[groupIndex].prices.forEach((price, index) => {
        price.selected = index === event.target.selectedIndex
      })
      this.modified = true
      this.trackTabTourCambiaCategoria()
    },
    onConfirmPrice () {
      this.updateTourPriceSelection(this.groups)
      this.modified = false
    },
    delta (prices, price) {
      const minPrice = prices.map(item => item.price.venditaTotaleEuro).reduce((t, c) => Math.min(t, c))
      return price - minPrice
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/tour-accompagnati/TourPanel.vue